import ICompany from "@/interfaces/companies/iCompany";
import { get } from "./apiService";

export const getAll = async (): Promise<ICompany[]> => {
	const urlPath = 'odoo/companies';

	const result = await get<ICompany[]>(urlPath);
	return result.data;
}